import { render, staticRenderFns } from "./Keyboard.vue?vue&type=template&id=387fd6ac&"
import script from "./Keyboard.vue?vue&type=script&lang=ts&"
export * from "./Keyboard.vue?vue&type=script&lang=ts&"
import style0 from "./Keyboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports